import { render, staticRenderFns } from "./suppilerOrder.vue?vue&type=template&id=6aa7977f&scoped=true"
import script from "./suppilerOrder.vue?vue&type=script&lang=js"
export * from "./suppilerOrder.vue?vue&type=script&lang=js"
import style0 from "./suppilerOrder.vue?vue&type=style&index=0&id=6aa7977f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7977f",
  null
  
)

export default component.exports